export const sort = [
  { label: "Lok.", name: "id", sortable: false },
  { label: "Nazwa", name: "name", sortable: false },
];
